export default "__VITE_ASSET__DDGe1Jnu__"